// Type-wise, this function is a disaster. I had to use many `as` castings
// because of how MetricTags<T> is built.
export default function buildParams(config, parameters) {
    var _config_metrics, _config_metrics1, _config_metrics2;
    var _config_metrics__tmp_disableAllowList;
    const disable = (_config_metrics__tmp_disableAllowList = (_config_metrics = config.metrics) === null || _config_metrics === void 0 ? void 0 : _config_metrics._tmp_disableAllowList) !== null && _config_metrics__tmp_disableAllowList !== void 0 ? _config_metrics__tmp_disableAllowList : true;
    const configAllowList = new Set((_config_metrics1 = config.metrics) === null || _config_metrics1 === void 0 ? void 0 : _config_metrics1.parametersAllowList);
    const configParameters = ((_config_metrics2 = config.metrics) === null || _config_metrics2 === void 0 ? void 0 : _config_metrics2.parameters) || {};
    const result = {};
    for(const key in configParameters){
        if (configParameters.hasOwnProperty(key)) {
            result[key] = configAllowList.has(String(key)) || disable ? configParameters[key] : '[REDACTED]';
        }
    }
    for(const key in parameters){
        if (parameters.hasOwnProperty(key)) {
            result[key] = configAllowList.has(String(key)) || disable ? parameters[key] : '[REDACTED]';
        }
    }
    if (Object.keys(result).length === 0) {
        return undefined;
    }
    return result;
}

//# sourceMappingURL=buildParams.js.map